// extracted by mini-css-extract-plugin
export var disabled = "_23-9";
export var error = "_23-1";
export var fitContent = "_23-a";
export var hasPrefix = "_23-6";
export var hasSuffix = "_23-4";
export var iconWrapper = "_23-d";
export var infoIconWrapper = "_23-g _23-d";
export var input = "_23-5";
export var inputWrapper = "_23-0";
export var large = "_23-8";
export var leadingIconWrapper = "_23-e _23-d";
export var measureBox = "_23-h";
export var medium = "_23-7";
export var prefix = "_23-c";
export var readonly = "_23-2";
export var small = "_23-3";
export var suffix = "_23-b";
export var trailingIconWrapper = "_23-f _23-d";